export var source_download_center = { "uid": "source_download_center", "fields": { "title": { "defaultValue": "" }, "no_results_title": { "defaultValue": "" }, "no_results_tips": { "defaultValue": "" } } };
